<template>
  <div
    class="flex items-center justify-center rounded-[4px] shrink-0 overflow-hidden"
    :class="meta.iconClass"
    :style="boxStyle"
  >
    <img
      v-if="logoSrc"
      :src="logoSrc"
      alt=""
      :class="{ 'w-full h-full': isIPracticomChatGpt || meta.logoFill }"
    />
    <span v-else class="material-symbols-outlined text-[24px]">
      {{ meta.icon }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { INTEGRATION_META } from '../constants';

const DEFAULT_META = { icon: 'extension', iconClass: 'bg-gray-100' };

export default {
  name: 'IntegrationIcon',
  props: {
    integrationId: { type: String, required: true },
    size: { type: Number, default: 48 },
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
    }),
    meta() {
      return INTEGRATION_META[this.integrationId] || DEFAULT_META;
    },
    isIPracticomChatGpt() {
      return (
        this.integrationId === 'openai' &&
        !!this.getAccount(this.accountId).platform_features?.iPracticom
      );
    },
    logoSrc() {
      if (this.isIPracticomChatGpt) {
        return '/dashboard/images/integrations/ipracticom.jpg';
      }
      return this.meta.logo
        ? `/dashboard/images/integrations/${this.meta.logo}`
        : '';
    },
    boxStyle() {
      return { width: `${this.size}px`, height: `${this.size}px` };
    },
  },
};
</script>
